import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { DeviceManagementConfigurationPolicy } from '@microsoft/microsoft-graph-types-beta';
import * as actions from './actions';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'graphDeviceConfigurationPolicies';

export interface State extends EntityState<DeviceManagementConfigurationPolicy>, Status {}

export const adapter: EntityAdapter<DeviceManagementConfigurationPolicy> =
    createEntityAdapter<DeviceManagementConfigurationPolicy>();

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    // load

    on(actions.loadDeviceConfigurationPoliciesSuccess, (state, action) =>
        adapter.upsertMany(action.data, { ...state, loaded: true, error: null, updating: false, creating: false }),
    ),

    on(actions.getOneConfigurationPolicySuccess, (state, action) =>
        adapter.upsertMany(action.data, { ...state, loaded: true, error: null, updating: false, creating: false }),
    ),

    on(actions.loadDeviceConfigurationPoliciesFailure, (state, { error }) => ({
        ...state,
        error,
        loaded: false,
    })),

    // create
    on(actions.createConfigurationPolicy, (state, action) => ({
        ...state,
        updating: true,
        error: null,
    })),

    on(actions.createConfigurationPolicyFailure, (state, { error }) => ({
        ...state,
        error,
        updating: false,
    })),

    on(actions.createConfigurationPolicyFailure, (state, { error }) => ({
        ...state,
        error,
        updating: false,
    })),

    //update
    on(actions.updateConfigurationPolicy, (state, action) => ({
        ...state,
        updating: true,
        error: null,
    })),

    on(actions.updateConfigurationPolicyFailure, (state, { error }) => ({
        ...state,
        error,
        updating: false,
    })),

    // delete
    on(actions.deleteConfigurationPolicy, (state, action) => ({
        ...state,
        updating: true,
        error: null,
    })),

    on(actions.deleteConfigurationPolicySuccess, (state, action) =>
        adapter.removeOne(action.id, { ...state, creating: false, error: null }),
    ),

    on(actions.deleteConfigurationPolicyFailure, (state, { error }) => ({
        ...state,
        error,
    })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
